export default __webpack_public_path__ + "static/media/LeftArrow.0d2f54ed.svg";